import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b5376cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "withdrawal-finished" }
const _hoisted_2 = { class: "px-3" }
const _hoisted_3 = { class: "text-center pt-5" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-black text-size-18 text-weight-500" }, [
  /*#__PURE__*/_createTextVNode("\n            早期引出の申請が"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("完了しました\n          ")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "summary-text" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14" }, "\n            ご登録いただいている銀行口座をご確認ください。\n          "),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14 mt-1" }, "\n            お振込みにはお時間を要する場合がありますが、24時間以上経過しても入金が確認できない場合、お問い合わせフォームよりご連絡ください。\n          "),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14 mt-1" }, "\n            早期引出でエラーが発生した場合、営業日（土日祝を除く平日9:00〜18:00）で対応させていただきます。\n          ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_NoSalary = _resolveComponent("NoSalary")!
  const _component_AppButtonOutline = _resolveComponent("AppButtonOutline")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_BlockBack = _resolveComponent("BlockBack")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, null, {
      default: _withCtx(() => [
        _createTextVNode("\n      早期引出申請完了\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_NoSalary),
          _createTextVNode(),
          _hoisted_4
        ]),
        _createTextVNode(),
        _hoisted_5,
        _createTextVNode(),
        _createVNode(_component_RouterLink, { to: { name: 'Salary' } }, {
          default: _withCtx(() => [
            _createVNode(_component_AppButtonOutline, {
              block: true,
              class: "text-primary-dark text-weight-500"
            }, {
              default: _withCtx(() => [
                _createTextVNode("給与詳細へ戻る")
              ], undefined, true),
              _: 1
            })
          ], undefined, true),
          _: 1
        })
      ])
    ]),
    _createTextVNode(),
    _createVNode(_component_BlockBack)
  ]))
}